import TicketsListView from './TicketsListView'

export default TicketsListView
